"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockStore = void 0;
var defaultValue_1 = require("./defaultValue");
var MockDataStore = /** @class */ (function () {
    function MockDataStore(_data) {
        if (_data === void 0) { _data = defaultValue_1.defaultMockData; }
        this._data = _data;
    }
    MockDataStore.prototype.save = function (d) {
        var data = typeof d === 'function' ? d(this._data) : d;
        if (this.validate(data)) {
            this._data = data;
        }
        else {
            console.error('invalid data', data);
        }
    };
    MockDataStore.prototype.clearAll = function () {
        this._data = defaultValue_1.defaultMockData;
    };
    MockDataStore.prototype.getMockData = function (key) {
        var d = this._data[key];
        return d;
    };
    MockDataStore.prototype.validate = function (data) {
        // WIP
        return true;
    };
    return MockDataStore;
}());
exports.mockStore = new MockDataStore();
